import { chartDomain } from "./chartSampling";

// Generate CSV from the original points, independently of Apex's sampled SVG
// data. Keep aligned rows (including duplicate timestamps) exactly as supplied.
export function fullChartCSV(series, config = {}, hiddenNames = new Set()) {
  const numeric = value => Number.isFinite(value) || (typeof value === "string" && value.trim() && Number.isFinite(Number(value)));
  if (config.xaxis?.type !== "datetime" || !chartDomain(series) || series.some(entry =>
    !Array.isArray(entry.data) || entry.data.some(point =>
      !(Array.isArray(point) ? Number.isFinite(point[0]) && (point[1] === null || numeric(point[1]))
        : point && Number.isFinite(point.x) && (point.y === null || numeric(point.y)))))) return null;
  const csv = config.chart?.toolbar?.export?.csv || {};
  const delimiter = csv.columnDelimiter || ",";
  const quote = value => {
    const text = String(value ?? "");
    return text.includes(delimiter) || /["\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
  };
  const x = point => Array.isArray(point) ? point[0] : point.x;
  const y = point => Array.isArray(point) ? point[1] : point.y;
  const date = value => quote(csv.categoryFormatter ? csv.categoryFormatter(value) : new Date(value).toISOString());
  const value = (point, index) => hiddenNames.has(series[index].name) || !point ? "" :
    quote(csv.valueFormatter ? csv.valueFormatter(y(point)) : y(point));
  const lines = [[csv.headerCategory || "Date", ...series.map((entry, i) => entry.name || `series-${i}`)].map(quote).join(delimiter)];
  const aligned = series.every(entry => entry.data.length === series[0].data.length &&
    entry.data.every((point, i) => x(point) === x(series[0].data[i])));
  if (aligned) {
    series[0].data.forEach((point, i) => lines.push([date(x(point)), ...series.map((entry, index) => value(entry.data[i], index))].join(delimiter)));
  } else {
    const rows = new Map();
    series.forEach((entry, index) => entry.data.forEach(point => {
      const key = x(point);
      if (!rows.has(key)) rows.set(key, Array(series.length).fill(""));
      rows.get(key)[index] = value(point, index);
    }));
    Array.from(rows.keys()).sort((a, b) => a - b).forEach(key => lines.push([date(key), ...rows.get(key)].join(delimiter)));
  }
  return "\uFEFF" + lines.join("\n");
}
